//node modules
import { Toaster } from "react-hot-toast";

//* Components
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import WhatIsMtProgram from "./components/WhatIsMtProgram";
import ProgramFlow from "./components/ProgramFlow";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import ApplicationForm from "./components/ApplicationForm";
import WhoCanApply from "./components/WhoCanApply";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  AOS.init({
    delay: 200,
    once: true,
  });

  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 7000,
        }}
      />
      <Navbar />
      <Header />
      <WhatIsMtProgram />
      <WhoCanApply />
      <ProgramFlow />
      <FAQ />
      <ApplicationForm />
      <Footer />
    </div>
  );
}

export default App;
